<template>
  <div class="terms-info mt-3 d-flex flex-column">
    <span class="terms-info__title mb-2">Production is not guaranteed</span>
    <p class="terms-info__description">
      This project will proceed if it reaches its goal by:
      {{ formattedClosingDate }}.
    </p>
    <p class="terms-info__description">
      If the project does not reach its publishing goal, you will be fully
      refunded the amount you pledge.
    </p>
    <p class="terms-info__description">
      For more information, see our
      <a href="/faq" target="_blank">FAQs</a> or our
      <a href="/terms" target="_blank">terms and conditions</a>.
    </p>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'TermsInfo',

  props: {
    closingDate: {
      type: String,
      default: null
    }
  },

  computed: {
    formattedClosingDate() {
      return dayjs(this.closingDate || new Date()).format('DD.MM.YY');
    }
  }
};
</script>

<style lang="scss">
.terms-info {
  &__title {
    font-size: 18px;
    font-weight: $font-weight-bold;
  }

  &__description {
    font-size: 14px;
    line-height: 18px;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
